var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"50","width":"5","color":"primary"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }